import styles from "../novellum/dash_styles/adminlogin.module.css"
import { UserContext } from "../context/UserContext"
import api from '../api/axios';

import getImgUrl from "../helper/getImgUrl";

import { useState, useContext, useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom";
import { PiDeviceRotateDuotone } from "react-icons/pi";

const AdminLogin = () => {
    const canvasRef = useRef(null);
    const { user, setUser } = useContext(UserContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.role === 'admin') {
            navigate('/admin/dashboard');
        }
    }, [user, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try{
            const res = await api.post('/login', { email, password });
            setUser(res.data.user);
            if (res.data.user.role === 'admin') {
                navigate('/admin/dashboard');
            } else {
                setError('You do not have admin access');
                setUser(null);
            }

        } catch (error) {
            console.error('Login failed', error);
            setError(error.response?.data?.message || 'Login Failed');
        }
    };


    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let animationFrameId;

        const resize = () => {
            const rect = canvasRef.current.getBoundingClientRect();
            canvasRef.current.width = rect.width;
            canvasRef.current.height = rect.height;
        };

        const generateNoise = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const imageData = ctx.createImageData(canvas.width, canvas.height);
            const buffer = new Uint32Array(imageData.data.buffer);
            for (let i = 0; i < buffer.length; i++) {
                buffer[i] = ((255 * Math.random()) | 0) << 24;
            }
            ctx.putImageData(imageData, 0, 0);
        };

        const loop = () => {
            generateNoise();
            animationFrameId = requestAnimationFrame(loop);
        };

        resize();
        loop();
        window.addEventListener("resize", resize);

        return () => {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener("resize", resize);
        };

    }, []);

    return(
        <div className={styles.main_body}>
            <canvas
                    ref={canvasRef} className={styles.canva}
                />
            <div className={styles.login}>
                <div className={styles.logo}>
                    <img src={getImgUrl("g5.svg")} alt=""/>
                </div>
                <div className={styles.title}>
                    <h3>Login</h3>
                    <p>Please sign-in to your admin account</p>
                </div>
                <div className={styles.form_login}>
                    <form onSubmit={handleLogin}>
                        <div className={styles.inputBox}>
                            <p>email</p>
                            <input 
                                type="email" 
                                placeholder="john@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        
                        <br/>
                        <div className={styles.inputBox}>
                            <p>password</p>
                            <input 
                                type="password" 
                                placeholder="............."
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        
                        <br/>
                        <br/>
                        <button>Login</button>
                    </form>
                    {error && <p>{error}</p>}
                </div>
            </div>
            
            {/*<div className={styles.rightpanel}>
                <div className={styles.logo}>
                    <img src="imgs/g5.svg" alt=""/>
                    <div className={styles.platformAccess}>
                       <p>To assure the best experience on our platform, only computer and tablet can have access to this platform</p>
                       <p>If you are on a tablet please rotate to landscape mode</p>
                       <PiDeviceRotateDuotone className={styles.rotate}/>
                    </div>
                    
                </div>
            </div>*/}
            
        </div>
    )
}

export default AdminLogin